import styled, { css } from "styled-components";

import { PasswordFieldControl as DefaultPasswordFieldControl } from "components/FormControl";
import LogoDefault from "components/Logo";
import DefaultRow from "components/Form/Row";
import DefaultPaper from "components/Layout/Paper";

import { MEDIA_QUERIES } from "constants/layout";
import { COLORS } from "constants/colorScheme";

const FORM_MIN_HEIGHT = 635;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  ${MEDIA_QUERIES.MOBILE} {
    min-height: ${FORM_MIN_HEIGHT}px
      ${({ windowHeight }: { windowHeight: number }) =>
        windowHeight &&
        css`
          height: ${windowHeight}px;
        `};
  }
`;

export const Paper = styled(DefaultPaper)`
  ${MEDIA_QUERIES.MOBILE} {
    min-height: ${FORM_MIN_HEIGHT}px
      ${({ windowHeight }: { windowHeight: number }) =>
        windowHeight &&
        css`
          height: ${windowHeight}px;
        `};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 60px 48px 0;

  width: 392px;

  &:after {
    content: "";
    display: block;
    height: 48px;
    width: 100%;
  }

  ${MEDIA_QUERIES.MOBILE} {
    flex: 1;
    width: 100vw;

    padding: 100px 20px 10px;

    ${({ isLandscapeMode }: { isLandscapeMode: boolean }) =>
      isLandscapeMode &&
      css`
        padding: 60px 20px 60px;
      `}

    &:after {
      content: "";
      display: block;
      height: 44px;
      width: 100%;
    }
  }
`;

export const Logo = styled(LogoDefault)`
  margin-bottom: 32px;
`;

export const InfoContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  margin: 0 auto;

  height: 100%;

  ${MEDIA_QUERIES.MOBILE} {
    height: unset;
    flex: 1;
  }
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Row = styled(DefaultRow)`
  margin-bottom: 56px;
  max-width: 335px;

  ${MEDIA_QUERIES.MOBILE} {
    max-width: 360px;
  }

  ${({ isTextRow }: { isTextRow?: boolean }) =>
    isTextRow &&
    css`
      margin: 0 auto;
      margin-bottom: 40px;
      && .MuiTypography-root {
        text-align: center;
      }
    `}
`;

export const ButtonWrapper = styled.div`
  padding-top: 22px;
  max-width: 335px;

  ${MEDIA_QUERIES.MOBILE} {
    padding-top: 0px;
    max-width: 360px;

    && .MuiButton-root {
      padding: 18px;
      font-size: 16px;
    }
  }
`;

export const PasswordFieldControl = styled(DefaultPasswordFieldControl)`
  && {
    background-color: ${COLORS.BLACK_4};
  }

  && .MuiFormHelperText-root {
    top: 53px;
  }
`;
